import React, { useEffect, useState } from "react";
import ICommonFormProps from "../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import { useTranslation } from "react-i18next";
import FormAlongsideText from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormAlongsideText";
import FormElement from "../../../yoello-lib/modules/dynamicForms/FormElement";
import { FormTippingElement } from "./FormTippingElement";
import { useWatch } from "react-hook-form";

interface FormTippingProps extends ICommonFormProps {
    fixed: boolean;
    text: string;
    sort_position: number;
    getValues: any;    
    isGroupPageTipping?:boolean;

}

/**
 * Form tipping component maps out the data to the 5 different options relies on tipping_enabled key
 * @param props 
 * @returns 
 */
export function FormTipping(props: FormTippingProps) {
    const { setValue, errors, triggerValidation, getValues, control } = props;
    const formState = getValues();
    const { t } = useTranslation();
    const [tippingState, setTippingState] = useState(props.value ?? {});
    /**Watch for tipping enabled to change */
    const enabled = useWatch({ control, name: "tipping_enabled" });

    useEffect(() => {
        if (!tippingState) return;
        setValue!(props.keyName, tippingState);
        triggerValidation!(props.keyName);
        const { setSelectedTipingOptions , selectedTipingOptions} = props.formProps!;
        if(tippingState.enabled){
            props.formProps?.setSelectedTipingOptions?.({...props.formProps?.selectedTipingOptions , [tippingState.id]:tippingState})
        }else{
            const selectedOptions = {...selectedTipingOptions};
            delete selectedOptions[tippingState.id]
            setSelectedTipingOptions(selectedOptions);
        }
        if (errors) {
            triggerValidation!(props.keyName);
        }
        // eslint-disable-next-line 
    }, [tippingState]);

    if (!enabled) {
        return null;
    }

    function onChange(key: string, state: any) {
        setTippingState((prevState: any) => ({
            ...prevState,
            [key]: state[key]
        }))
    }

    return <FormElement {...props}>
        <>
        {(props.isGroupPageTipping && props.sort_position === 1) && <p style={{
            color:"#8D98B7",
            fontSize:"1rem"
        }}>{t("tipping.groupTippingCaption")}</p>}

            {props.sort_position === 1 ? (
                <>
                    <FormAlongsideText
                        label={t("tipping.title")}
                        secondLabel={t("tipping.caption")}
                    />
                </>
            ) : null}

            <FormTippingElement {...tippingState}
                formData={tippingState}
                onChange={onChange}
                errors={errors}
                fixed={props.fixed}
                text={props.text}
                keyName={props.keyName}
                formState={formState}
                disabled={props.disabled}
            />

        </>
    </FormElement>
}
